// extracted by mini-css-extract-plugin
module.exports = {"lia-header":"DeleteActionModal_lia-header__tJBAj","lia-title":"DeleteActionModal_lia-title__pnYpj","lia-body":"DeleteActionModal_lia-body__teB_K"};